import {useMemo} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {formatRating, plural} from 'core/helpers';
import {BUTTON_VARIANTS, CreateProductReviewDialog} from '../CreateProductReviewDialog';
import {RatingMarksStatistics} from 'modules/products/components/RatingMarksStatistics';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {useReviewsMeta} from 'modules/product-card/hooks/useReviewsMeta';
import {PLURAL_REVIEW_RATING_WORDS} from 'modules/products/constants';

export const ProductRatingCard = () => {
    const productData = useAppSelector(selectProductData);
    const {ratings} = productData || {};

    const {reviewRating, total} = useReviewsMeta(ratings);

    const description = useMemo(() => {
        const assessmentsCount = total.assessmentsCount;

        const text = `На основании ${assessmentsCount}\u00A0${plural(assessmentsCount, PLURAL_REVIEW_RATING_WORDS)}`;

        return (
            <Typography className={style.ratingSubtitle} variant={'label-16-r'}>
                {text}
            </Typography>
        );
    }, [total]);

    return (
        <>
            <div className={style.productRatingCard}>
                <div className={style.ratingValueWrapper}>
                    <div>
                        <Typography className={style.ratingTitle} variant={'h2-custom-regular'}>
                            Рейтинг
                        </Typography>
                        <Typography className={style.ratingDescription} element={'div'} variant={'label-16-r'}>
                            {description}
                        </Typography>
                    </div>
                    <Typography
                        className={style.ratingValue}
                        color={'primary100'}
                        element={'h2'}
                        variant={'h2-custom-regular'}
                    >
                        {formatRating(reviewRating)}
                    </Typography>
                </div>
                <div className={style.body}>
                    <div className={style.statWrapper}>
                        <div>
                            <RatingMarksStatistics />
                        </div>
                        <div className={style.footer}>
                            <CreateProductReviewDialog buttonVariant={BUTTON_VARIANTS.TEXT} isStretched={true} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
